// Element ui form validator
export function validateEmptyString (rule, value, cb) {
  if (!value.trim()) {
    cb(new Error())
  } else {
    cb()
  }
}
